import { createFileRoute } from "@tanstack/react-router";
import { ColleaguesCard } from "@/components/dashboard/colleagues-card";
import { ExamAnnounce } from "@/components/dashboard/exam-announce";
import { ExamResultsAnnounce } from "@/components/dashboard/exam-results-announce";
import { NPSCard } from "@/components/dashboard/nps-card";
import { PerformanceCard } from "@/components/dashboard/performance-card";
import { SisuSimulatorCard } from "@/components/dashboard/sisu-simulator-card";
import { StatsCards } from "@/components/dashboard/stats-cards";

export const Route = createFileRoute("/_app/painel/")({
	component: DashboardPage,
});

function DashboardPage() {
	return (
		<div className="flex flex-col items-center lg:items-start lg:flex-row lg:gap-8 lg:max-w-7xl lg:mx-auto lg:mb-10 w-full px-4 lg:px-8">
			{/* Left Section */}
			<div className="flex flex-col w-full lg:w-2/3 lg:mt-10 lg:z-30 gap-6">
				<StatsCards />
				<ExamAnnounce />
				<ExamResultsAnnounce />
				<NPSCard />
			</div>

			{/* Right Section */}
			<div className="flex flex-col lg:mt-10 lg:z-30 gap-6 w-full lg:min-w-[336px] lg:w-1/3 mt-8 mb-8 lg:mb-0">
				<PerformanceCard />
				<ColleaguesCard />
				<SisuSimulatorCard />
			</div>
		</div>
	);
}
